import { render, staticRenderFns } from "./feeding-report.vue?vue&type=template&id=5f9380fb&"
import script from "./feeding-report.vue?vue&type=script&lang=js&"
export * from "./feeding-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "feeding-report.vue"
export default component.exports